import React, { useContext, useEffect, useState } from "react";
import "./All_Orders.css";
import Heading_banner_section from "../common_components/heading_banner/Heading_banner_section";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Order_card from "./order_card/Order_card";
import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";
import Add_Reviews from "../common_components/add_Reviews/Add_Reviews";
import {
  getOrder,
  OrderCount,
} from "../../utils/luxuryapis/orderProcess/orderProcess";
import { Context } from "../../utils/context";
import { OrderStatus } from "../../utils/apis/master/Master";
import LogoutModal from "../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";

function All_Orders() {
  const [showReviewModal, setShowReviewModal] = useState(false);

  const handleOpenModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseModal = () => {
    setShowReviewModal(false);
  };
  const [rating, setRating] = useState(0);

  // ✅ status tab state
  const [activeStatus, setActiveStatus] = useState("");

  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "YOUR ACCOUNT", link: "/luxury/account" },
    { label: "ALL ORDER" },
  ];

  const ordersData = [
    {
      img: "/assest/luxury_images/gifts/img1.png",
      status: "ORDERED",
      title: "GPAC URI PITCHER",
      description: "Hammered 1500ml (copper pitcher with tumbler...)",
      mrp: "34560",
      date: "3.JUN.24",
      sellingPrice: "2000",
      discount: "30% Discount",
    },
    {
      img: "/assest/luxury_images/gifts/img1.png",
      status: "SHIPPED",
      title: "COPPER BOTTLE",
      description: "Pure copper bottle 1000ml...",
      mrp: "12000",
      date: "10.JUN.24",
      sellingPrice: "8500",
      discount: "20% Discount",
    },
    {
      img: "/assest/luxury_images/gifts/img1.png",
      status: "RETURNED",
      title: "GPAC URI PITCHER",
      description: "Hammered 1500ml (copper pitcher with tumbler...)",
      mrp: "34560",
      date: "3.JUN.24",
      sellingPrice: "2000",
      discount: "30% Discount",
    },
    {
      img: "/assest/luxury_images/gifts/img1.png",
      status: "DELIVERED",
      title: "COPPER BOTTLE",
      description: "Pure copper bottle 1000ml...",
      mrp: "12000",
      date: "10.JUN.24",
      sellingPrice: "8500",
      discount: "20% Discount",
    },

    {
      img: "/assest/luxury_images/gifts/img1.png",
      status: "CANCELLED",
      title: "COPPER BOTTLE",
      description: "Pure copper bottle 1000ml...",
      mrp: "12000",
      date: "10.JUN.24",
      sellingPrice: "8500",
      discount: "20% Discount",
    },
  ];

  // function to return class based on status
  const getStatusClass = (status) => {
    return status === "ORDERED"
      ? "ordered"
      : status === "RETURNED"
      ? "returned"
      : status === "SHIPPED"
      ? "shipped"
      : status === "DELIVERED"
      ? "deliverd"
      : status === "CANCELLED"
      ? "cancelled"
      : "";
  };

  // ✅ filter cards based on activeStatus
  const filteredOrders =
    activeStatus === "ALL"
      ? ordersData
      : ordersData.filter((order) => order.status === activeStatus);

  // ✅ dynamic counts
  const totalCount = ordersData.length;
  const orderedCount = ordersData.filter((o) => o.status === "ORDERED").length;
  const shippedCount = ordersData.filter((o) => o.status === "SHIPPED").length;
  const deliveredCount = ordersData.filter((o) => o.status === "DELIVERED")
    .length;
  const returnedCount = ordersData.filter((o) => o.status === "RETURNED")
    .length;
  const cancelledCount = ordersData.filter((o) => o.status === "CANCELLED")
    .length;

  const [orderData, setOrderData] = useState();
  const orderGet = async (activeStatus) => {
    const res = await getOrder(activeStatus);
    if (res?.success) {
      setOrderData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    orderGet(activeStatus);
    // orderStatusget();
  }, [activeStatus]);

  const { IMG_URL, signin, userdata, setSignin } = useContext(Context);

  const [orderStatus, setOrderStatus] = useState();
  const orderStatusget = async () => {
    const res = await OrderCount();
    if (res?.success) {
      setOrderStatus(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    orderStatusget();
  }, []);
  const [logoutshow, setLogoutshow] = useState(false);
  return (
    <>
      <section className="All_Orders">
        <Heading_banner_section
          headingText={`${userdata?.first_name} ${userdata?.last_name}`}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="all_order_section_holder">
            <div className="text_holder">
              <h3 className="sign_out_text" onClick={() => setLogoutshow(true)}>
                <FontAwesomeIcon
                  className="me-3"
                  icon={faArrowRightFromBracket}
                />
                SIGN OUT
              </h3>
            </div>

            <div className="heading_tab_content_holder">
              <div className="row">
                <div className="col-md-4">
                  <div className="heading_holder">
                    <h1>ALL ORDERS</h1>
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="tab_holder">
                    {/* ✅ ALL */}
                    <div
                      className={`tab_text_holder ${
                        activeStatus === "" ? "active" : ""
                      }`}
                      onClick={() => setActiveStatus("")}
                    >
                      <p>ALL ORDER ({orderStatus?.total_orders})</p>
                    </div>

                    {orderStatus?.status_counts?.map((val) => (
                      <div
                        className={`tab_text_holder ${
                          activeStatus === val?.id ? "active" : ""
                        }`}
                        onClick={() => setActiveStatus(val?.id)}
                      >
                        <p>
                          {val?.order_status} ({val?.count})
                        </p>
                      </div>
                    ))}

                    {/* <div
                      className={`tab_text_holder ${
                        activeStatus === "SHIPPED" ? "active" : ""
                      }`}
                      onClick={() => setActiveStatus("SHIPPED")}
                    >
                      <p>SHIPPED ({shippedCount})</p>
                    </div>

                    <div
                      className={`tab_text_holder ${
                        activeStatus === "DELIVERED" ? "active" : ""
                      }`}
                      onClick={() => setActiveStatus("DELIVERED")}
                    >
                      <p>DELIVERED ({deliveredCount})</p>
                    </div>

                    <div
                      className={`tab_text_holder ${
                        activeStatus === "RETURNED" ? "active" : ""
                      }`}
                      onClick={() => setActiveStatus("RETURNED")}
                    >
                      <p>RETURNED ({returnedCount})</p>
                    </div>

                    <div
                      className={`tab_text_holder ${
                        activeStatus === "CANCELLED" ? "active" : ""
                      }`}
                      onClick={() => setActiveStatus("CANCELLED")}
                    >
                      <p>CANCELLED ({cancelledCount})</p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ Order Cards */}
          <div className="order_cards_section_holder">
            <div className="row ">
              {orderData && orderData.length > 0 ? (
                orderData.map((order, index) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mb-3"
                    key={index}
                  >
                    <Order_card
                      orderGet={orderGet}
                      img={
                        IMG_URL +
                        order.product_variant?.product_images[0]?.image
                      }
                      status={order.order_status?.order_status}
                      statusClass={getStatusClass(order.status)}
                      title={order.porduct?.name}
                      description={order.product.short_description}
                      mrp={order.mrp}
                      date={order.date}
                      sellingPrice={order.price}
                      order={order}
                      discount={order.discount}
                      onAddReviewClick={handleOpenModal}
                    />
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <div style={{ fontSize: "50px" }}>📦</div>
                  <h5>No Orders Found</h5>
                  <p style={{ color: "#777" }}>
                    You have not placed any orders yet.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* <div className="star_rate_holder">
            <p>
              Rate this Product :-{" "}
              <Rating
                style={{ maxWidth: 100 }}
                value={rating}
                onChange={setRating}
              />
            </p>
          </div> */}
        </div>
        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>

      {/* <Add_Reviews show={showReviewModal} onHide={handleCloseModal} /> */}
    </>
  );
}

export default All_Orders;
